var _defs, _rect, _g, _text, _text2, _text3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProductImagePlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#e8f5f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f5f5f7"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    rx: 20,
    fill: "url(#bg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(200,160)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -10,
    r: 45,
    fill: "none",
    stroke: "#0e7c62",
    strokeWidth: 2,
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -25,
    width: 40,
    height: 30,
    rx: 4,
    fill: "none",
    stroke: "#0e7c62",
    strokeWidth: 2,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -8,
    cy: -14,
    r: 5,
    fill: "#0e7c62",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20,5 L-8,-8 L2,2 L10,-5 L20,5",
    fill: "none",
    stroke: "#0e7c62",
    strokeWidth: 1.5,
    opacity: 0.3,
    strokeLinecap: "round"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 235,
    textAnchor: "middle",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 14,
    fontWeight: 600,
    fill: "#0e7c62",
    opacity: 0.4
  }, "Product Image")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 258,
    textAnchor: "middle",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 11,
    fill: "#86868b",
    opacity: 0.5
  }, "Replace with actual photo")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 278,
    textAnchor: "middle",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 10,
    fill: "#aeaeb2",
    opacity: 0.4
  }, "Recommended: 800x800px, PNG/WebP")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductImagePlaceholder);
export default __webpack_public_path__ + "static/media/product-image-placeholder.984055454e5c393f9e2dfbb5cdc56d63.svg";
export { ForwardRef as ReactComponent };